// extracted by mini-css-extract-plugin
module.exports = {"questionVoteBox":"vs","upvote":"ws","downvote":"xs","numVotes":"ys","votesDescription":"zs","report":"As","voted":"Bs","answerVoteBox":"Cs","justReported":"Ds"};